import { ActionIcon, Button } from '@mantine/core';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import HelpIcon from 'shared/ui/assets/icons/help-icon.svg?react';
import { gameHelpModalModel } from '../../model';

export const GameHelpModalButton = () => {
	const { t } = useTranslation();
	const enable = useUnit(gameHelpModalModel.switcher.enable);

	return (
		<Button
			variant='standard'
			leftSection={
				<ActionIcon
					variant='secondary'
					component='div'
				>
					<HelpIcon />
				</ActionIcon>
			}
			onClick={enable}
		>
			{t('game-help-modal.button-label')}
		</Button>
	);
};
